<template>
  <div class="auth-bg overflow-auto">
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="5">
        <v-card class="text-center mt-16">
          <v-card-title class="d-flex flex-column justify-center align-center">
            <v-img width="140" src="../../assets/logo.png" class="px-4"></v-img>
            <div class="mt-4 px-10 d-flex flex-column">
                <div class="text-h3 text-center font-weight-black" style="color: #ca8a04 ;">AUMS</div>
                <div class="text-h6 text-center font-weight-normal" style="color: #000000 ;">Academic Unit Monitoring System</div>
            </div>
          </v-card-title>
          <v-card-text>
            <h2 class="headline">Page Not Found</h2>
            <p class="subheading">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
            <v-btn color="darkGreen" to="/">Back to Home</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>
  .headline {
    margin-top: 10px;
  }

  .subheading {
    margin-bottom: 20px;
  }

.auth-bg {
  background-image: url('../../assets/background.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position:fixed;
  left:0;right:0;top:0;bottom:0;
}
</style>